import { render, staticRenderFns } from "./productMode.vue?vue&type=template&id=15819f86&scoped=true&"
import script from "./productMode.vue?vue&type=script&lang=js&"
export * from "./productMode.vue?vue&type=script&lang=js&"
import style0 from "./productMode.vue?vue&type=style&index=0&id=15819f86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15819f86",
  null
  
)

export default component.exports